import api from './api';

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/**
 * Confirm jackpot claim with retries (RPC may lag before receipt is available).
 */
export async function confirmJackpotClaim({ predictionId, txHash, walletAddress, maxAttempts = 4 }) {
  let lastError;
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      const { data } = await api.post(`/jackpots/claim/${predictionId}/confirm`, {
        txHash,
        walletAddress,
      });
      return data;
    } catch (e) {
      lastError = e;
      const status = e?.response?.status;
      if ((status === 404 || status >= 500) && attempt < maxAttempts - 1) {
        await sleep(2000 * (attempt + 1));
        continue;
      }
      throw e;
    }
  }
  throw lastError;
}

/**
 * Confirm boost/market claim with retries.
 */
export async function confirmPredictionClaim({ predictionId, txHash, walletAddress, maxAttempts = 4 }) {
  let lastError;
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      const { data } = await api.post(`/predictions/${predictionId}/claim`, {
        txHash,
        walletAddress,
      });
      return data;
    } catch (e) {
      lastError = e;
      const status = e?.response?.status;
      if ((status === 404 || status >= 500) && attempt < maxAttempts - 1) {
        await sleep(2000 * (attempt + 1));
        continue;
      }
      throw e;
    }
  }
  throw lastError;
}
